import { PageHeader } from '../components/PageHeader';

const endpoints = [
  ['GET', '/mcp/tools'],
  ['GET', '/mcp/orchestration-scores'],
  ['POST', '/mcp/recommend'],
  ['POST', '/mcp/export-workflow'],
  ['GET', '/mcp/docs'],
  ['GET', '/mcp/docs/:id'],
  ['GET', '/mcp/docs?topic=firebase']
];

export function McpDocsPage() {
  return (
    <section className="page">
      <PageHeader title="MCP endpoint documentation" description="Prepared contracts for future MCP clients and server adapters." />
      <div className="grid cols-2">
        {endpoints.map(([method, path]) => (
          <article className="card" key={path}>
            <span className="badge good">{method}</span>
            <h2 className="section-title">{path}</h2>
            <p className="muted">Available through Cloudflare Pages Functions. Document routes return Markdown directly.</p>
          </article>
        ))}
      </div>
    </section>
  );
}
